export function getFileNameAndExtension(filename: string) {
  const lastDotIndex = filename.lastIndexOf(".");

  // No dot or dot is the first character (hidden files in Unix)
  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return { baseName: filename, extension: "" };
  }

  const baseName = filename.slice(0, Math.max(0, lastDotIndex));
  const extension = filename.slice(Math.max(0, lastDotIndex)); // Includes the dot

  return { baseName, extension };
}
